<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-fencing`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38.264 9.15a1 1 0 010 1.415L26.828 21.999l3.572 3.573a9.004 9.004 0 0113.272 4.599l.423 1.19-3.952 3.952 2.12 2.122a1 1 0 01.078 1.327l-.078.087-1.414 1.414a1 1 0 01-1.327.078l-.087-.078-2.12-2.121-3.953 3.953-1.191-.423A9.003 9.003 0 0127.572 28.4L24 24.827 20.428 28.4a9.004 9.004 0 01-4.599 13.272l-1.19.423-3.953-3.953-2.121 2.121a1 1 0 01-1.414 0L5.737 38.85a1 1 0 010-1.414l2.12-2.122-3.952-3.952.423-1.19a8.971 8.971 0 012.116-3.343c3.028-3.028 7.679-3.447 11.156-1.256l3.572-3.573L9.737 10.565a1 1 0 01-.078-1.327l.078-.087 1.414-1.414a1 1 0 011.327-.078l.087.078L24 19.17 35.435 7.737a1 1 0 011.414 0l1.415 1.414zm-21.92 20.507a5 5 0 00-7.709.778l6.93 6.93a5 5 0 00.778-7.708zm22.384 0a5 5 0 00-6.89-.172l-.15.141-.061.061a5 5 0 00-.12 6.884l.15.157c.24.24.501.453.778.637l6.93-6.93a5.028 5.028 0 00-.637-.778z"/></svg>
</template>
<script>

export default {
  name: 'IconFencing',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
